var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-plus',
                        view: publicPath + 'sprite.svg#view-icon-plus',
                        viewBox: '0 0 40 40',
                        title: 'icons/fonctions/plus',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };